var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("header-block", { attrs: { "is-transparent": true } }),
      _vm._v(" "),
      _c("section", { staticClass: "hero-section" }, [
        _c("div", { staticClass: "split-container" }, [
          _c(
            "div",
            {
              staticClass: "split-container__item split-container__item--left"
            },
            [
              _c("div", { staticClass: "split-container__item__copy" }, [
                _c("picture", { staticClass: "hero-section__ilustration" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "split-container__item__text" }, [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.$t("Sign-up witouth any cost")))
                    ]),
                    _vm._v(" "),
                    _c("h4", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "Manage your insurance policies and receipts"
                            )
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _c("h4", [
                      _vm._v(
                        " " + _vm._s(_vm.$t("Speak with your account manager"))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(2)
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "split-container__item split-container__item--right"
            },
            [
              _c("a", { attrs: { href: "/" } }, [
                _c("div", { staticClass: "content-svg" }, [_c("kw-close")], 1)
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "split-container__item__copy" }, [
                _c(
                  "div",
                  { staticClass: "form-container" },
                  [
                    _vm.passwordChanged == false
                      ? [
                          _c("div", { staticClass: "form__title" }, [
                            _c("img", {
                              staticClass:
                                "split-container__item--right__only-mobile",
                              attrs: {
                                src: require("../../../../assets/logo4login.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("h3", { staticClass: "text-h3" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Write your new password on the input above."
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.serverValidationError
                            ? _c("div", { staticClass: "form-error" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$i18n.t(
                                        _vm.serverValidationErrorMessage
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { on: { click: _vm.removeMessage } },
                                  [_c("kw-close")],
                                  1
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("kw-password", {
                            attrs: {
                              label: _vm.$t("New password"),
                              isUnique: false,
                              placeholder: _vm.$t("Your new password")
                            },
                            model: {
                              value: _vm.form.password,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password"
                            }
                          }),
                          _vm._v(" "),
                          _c("kw-button", {
                            attrs: {
                              label: _vm.$t("Set new password"),
                              isPrimary: true,
                              type: "submit",
                              isLoading: _vm.isLoading,
                              disabled: _vm.isFormValid
                            },
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.onSubmit($event)
                              }
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.sendEmail($event)
                              }
                            }
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.passwordChanged == true
                      ? [
                          _c("div", { staticClass: "form__title" }, [
                            _c("img", {
                              staticClass:
                                "split-container__item--right__only-mobile",
                              attrs: {
                                src: require("../../../../assets/logo4login.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("h3", { staticClass: "text-h3" }, [
                              _vm._v(_vm._s(_vm.$t("Recover your password")))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-info" }, [
                              _c(
                                "svg",
                                {
                                  staticStyle: {
                                    "enable-background":
                                      "new 0 0 367.805 367.805"
                                  },
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    version: "1.1",
                                    id: "Capa_1",
                                    x: "0px",
                                    y: "0px",
                                    viewBox: "0 0 367.805 367.805",
                                    "xml:space": "preserve",
                                    width: "90px",
                                    height: "90px"
                                  }
                                },
                                [
                                  _c("g", [
                                    _c("g", [
                                      _c("path", {
                                        staticClass: "active-path",
                                        staticStyle: { fill: "#78AD9F" },
                                        attrs: {
                                          d:
                                            "M183.903,0.001c101.566,0,183.902,82.336,183.902,183.902s-82.336,183.902-183.902,183.902   S0.001,285.469,0.001,183.903l0,0C-0.288,82.625,81.579,0.29,182.856,0.001C183.205,0,183.554,0,183.903,0.001z",
                                          "data-original": "#3BB54A",
                                          "data-old_color": "#3BB54A"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("polygon", {
                                        staticStyle: { fill: "#FEFEFE" },
                                        attrs: {
                                          points:
                                            "285.78,133.225 155.168,263.837 82.025,191.217 111.805,161.96 155.168,204.801    256.001,103.968  ",
                                          "data-original": "#D4E1F4",
                                          "data-old_color": "#D4E1F4"
                                        }
                                      })
                                    ])
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Done. Check your email and follow the instructions"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("kw-button", {
                                attrs: {
                                  label: _vm.$t("Close"),
                                  isPrimary: true,
                                  type: "submit"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.redirect($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [_c("br")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "split-container__item__logo" }, [
      _c("img", {
        attrs: { src: require("../../../../assets/logo4login.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "split-container__item__image" }, [
      _c("img", { attrs: { src: require("../../../../assets/teste1.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60752f28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60752f28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/views/ResetPassword/ResetPassword.html
// module id = null
// module chunks = 